import React from "react";
import styled from "styled-components";
import LogoRound from "../Svg/Icons/LogoRound";
import Text from "../Text/Text";
import Skeleton from "../Skeleton/Skeleton";
import { Colors } from "../../theme";

export interface Props {
  color?: keyof Colors;
  cakePriceUsd?: number;
  showSkeleton?: boolean;
  chainId: number;
}

const PriceLink = styled.div`
  display: flex;
  align-items: center;
  svg {
    transition: transform 0.3s;
  }
  :hover {
    svg {
      transform: scale(1.2);
    }
  }
`;

const CakePrice: React.FC<React.PropsWithChildren<Props>> = ({
  cakePriceUsd,
  color = "textSubtle",
  showSkeleton = true,
  chainId,
}) => {
  return cakePriceUsd ? (
    <div
      style={{
        background: "#120f1f",
        borderRadius: "50px",
        padding: "2px 0px",
        width: "fit-content",
        paddingRight: "10px",
      }}
    >
      <PriceLink href={`#`} target="_blank">
        <LogoRound width="24px" mr="8px" />
        <Text color={color} bold paddingLeft={1}>{`${cakePriceUsd.toFixed(3)} KAS`}</Text>
      </PriceLink>
    </div>
  ) : showSkeleton ? (
    <Skeleton width={80} height={24} />
  ) : null;
};

export default React.memo(CakePrice);
